import React, { FC, useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
//import Badge from "./Badge";
import Button from "shared/Button/Button";
import ProductBadge from "components_custom/ProductBadge/ProductBadge";
import Badge from "pages/Home/Badge";

const ReservationCard = ({
	data,
}: any) => {

	// const getTripDuration = (
	// 	start: string,
	// 	end:string
	// ) => {
	// 	const startDate = new Date(start);
	// 	const endDate = new Date(end);
	  
	// 	// 밀리초 단위로 차이 계산
	// 	const diffTime = Math.abs(endDate.getTime() - startDate.getTime());
		
	// 	// 일 수 차이 계산
	// 	const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
	  
	// 	// 시간 차이 계산 (분 단위로 반올림)
	// 	const diffHours = Math.round((diffTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
	  
	// 	if (diffDays === 0 && diffHours < 24) {
	// 	  return "무박 1일";
	// 	} else if (diffDays === 1 || (diffDays === 0 && diffHours >= 24)) {
	// 	  return "1박 2일";
	// 	} else {
	// 	  return `${diffDays}박 ${diffDays + 1}일`;
	// 	}
	// };

	const getTripDuration = (
		_reservationStart: string,
		_reservationEnd:string
	  ) => {
		const startDate = new Date(_reservationStart);
		const endDate = new Date(_reservationEnd);

		// Check for special case: both dates are 2023-12-31
		if (startDate.toISOString().startsWith('2023-12-31') && 
			endDate.toISOString().startsWith('2023-12-31')) {
		  return "상시일정";
		}
	  
		// 밀리초 단위로 차이 계산
		const diffTime = Math.abs(endDate.getTime() - startDate.getTime());
		
		// 일 수 차이 계산
		const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
	  
		// 시간 차이 계산 (분 단위로 반올림)
		const diffHours = Math.round((diffTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
	  
		if (diffDays === 0 && diffHours < 24) {
		  return "무박 1일";
		} else if (diffDays === 1 || (diffDays === 0 && diffHours >= 24)) {
		  return "1박 2일";
		} else {
		  return `${diffDays}박 ${diffDays + 1}일`;
		}
	  };

	const formatKoreanDate = (dateString: string) => {
		const date = new Date(dateString);
		
		const year = date.getFullYear();
		const month = ('0' + (date.getMonth() + 1)).slice(-2);
		const day = ('0' + date.getDate()).slice(-2);
		
		let hours = date.getHours();
		const minutes = ('0' + date.getMinutes()).slice(-2);
		const seconds = ('0' + date.getSeconds()).slice(-2);
	
		const period = hours >= 12 ? '오후' : '오전';
		hours = hours % 12 || 12; // 0 => 12
	
		const formattedDate = `${year}-${month}-${day}`;
		const formattedTime = `${period} ${hours}:${minutes}:${seconds}`;
	
		return {
			date: formattedDate,
			time: formattedTime,
			year: year,
			month: month,
			day: day,
		};
	};

	console.log("r333", data);
	console.log("r333", data.productInfo);

	if (data.productInfo === undefined) return (<></>);

	const _reservationSchedule = getTripDuration(data.productInfo.product_travelStart, data.productInfo.product_travelEnd);
	const travelStart: any = formatKoreanDate(data.productInfo.product_travelStart);
	const travelEnd: any = formatKoreanDate(data.productInfo.product_travelEnd);


	if (Object.keys(data).length === 0) return (<></>)

		return (
		
		<div
			className={`group bg-white dark:bg-neutral-900 border border-neutral-100 dark:border-neutral-800 rounded-3xl overflow-hidden shadow-xl transition-shadow`}
		>
			{/* <Link to={`/reservation/${data.no}`} className="absolute inset-0"></Link> */}

			<div className="w-full flex">
				<div className="flex-shrink-0 p-2 w-[6rem]">
					<div className={`block aspect-w-1 aspect-h-1`}>

						{data.productInfo.product_cover === null
						?
						<></>
						:
							data.productInfo.product_cover.type === "video"
							?
								<video 
									className="object-cover w-full h-full rounded-2xl overflow-hidden will-change-transform"
									loop 
									muted
									autoPlay
									playsInline  // Safari에서 인라인 재생을 강제
									controls={false}  // 컨트롤 숨김
									disablePictureInPicture  // PiP 모드 비활성화
									webkit-playsinline="true"  // iOS Safari 지원
									src={`${process.env.REACT_APP_SERVER_FILE}/products/${data.product_no}/${data.productInfo.product_cover.src}`}
								/>
							:
								<img
									src={`${process.env.REACT_APP_SERVER_FILE}/products/${data.product_no}/${data.productInfo.product_cover.src}`}
									className={"object-cover w-full h-full rounded-2xl overflow-hidden will-change-transform"}
								/>
						}
					</div>
				</div>

				<div className="flex-grow p-2 flex flex-col items-start">
					<div className="space-y-[1px] w-full">
						<div>
							<div className="flex items-center space-x-2">
								
								<span 
									className="line-clamp-1 text-[0.95rem]" 
									style={{fontWeight: "600", color:"#282f33"}}
								>
									{data.productInfo.product_title}
								</span>
								
							</div>
						</div>
						<div className="flex items-center">
							<div className="text-[0.80rem] md:text-[0.95rem] space-x-1" style={{fontWeight: "500", color:"#586066"}}>
								
								<span className="tracking-tighter">
									{travelStart.date}
								</span>
								<span className="">
									~
								</span>
								<span className="tracking-tighter">
									{travelEnd.date}
								</span>
							</div>
							<span className="pl-1 text-[0.85rem]" style={{fontWeight: "500", color:"#586066"}}>
								({_reservationSchedule})
							</span>
							
						</div>	
						<div>
							<Badge
								type={data.productInfo.product_category}
								href={""}
								color={"gray"}
							/>
						</div>
						
					</div>
				</div>
			</div>

			
		</div>
		
	);
};

export default ReservationCard;